import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pl';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import CustomerAddPage from './components/CustomerAddPage';
import CustomersPage from './components/CustomersPage';
import LoginPage from './components/LoginPage';
import ParpDocsPage from './components/ParpDocsPage';

function App() {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl">
            <Router>
                <Routes>
                    <Route path="/" element={<CustomersPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/add-customer" element={<CustomerAddPage />} />
                    <Route path="/parp-docs" element={<ParpDocsPage />} />
                </Routes>
            </Router>
        </LocalizationProvider>
    );
}

export default App;
